import { DEFAULT_GETTERS } from '@/constants'

export default {
  ...DEFAULT_GETTERS,
  listPlan: state => state.listPlan,
  subscriptionStatus: state => state.subscriptionStatus,
  histories: state => state.histories,
}
